var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFraud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 72,
    viewBox: "0 0 73 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.15,
    x: 16.667,
    width: 56,
    height: 56,
    rx: 8,
    fill: "#EB5757"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.334 46.3333C42.8093 46.3333 45.1833 47.3167 46.9336 49.067C48.684 50.8173 49.6673 53.1913 49.6673 55.6667C49.6673 58.142 48.684 60.516 46.9336 62.2663C45.1833 64.0167 42.8093 65 40.334 65C35.336 65 31.0007 60.8233 31.0007 55.6667H26.334C26.3331 57.931 25.5091 60.1179 24.0154 61.8197C22.5217 63.5216 20.4603 64.6224 18.2152 64.917C15.97 65.2117 13.6944 64.6801 11.8121 63.4213C9.9299 62.1625 8.56948 60.2624 7.98433 58.0749C7.39919 55.8874 7.62923 53.5619 8.6316 51.5314C9.63397 49.501 11.3403 47.9042 13.4327 47.0386C15.5251 46.173 17.8608 46.0975 20.0047 46.8263C22.1485 47.5551 23.9543 49.0385 25.0857 51H32.249C33.068 49.5805 34.2464 48.4018 35.6658 47.5826C37.0851 46.7634 38.6952 46.3325 40.334 46.3333V46.3333ZM5.33398 44V39.3333H10.0007V32.3333C10.0007 29.858 10.984 27.484 12.7343 25.7337C14.4847 23.9833 16.8586 23 19.334 23H38.0007C40.476 23 42.85 23.9833 44.6003 25.7337C46.3507 27.484 47.334 29.858 47.334 32.3333V39.3333H52.0007V44H5.33398Z",
    fill: "#EB5757"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFraud);
export default __webpack_public_path__ + "static/media/Icon_Fraud.eb03efc0a3d7346696b1df1b36be1231.svg";
export { ForwardRef as ReactComponent };